import Wahanda from './wahanda';

export default Wahanda.LocalStorage;
